export const GET_STREETS_REQUEST = 'resources/streets/GET_STREETS_REQUEST'
export const GET_STREETS_SUCCESS = 'resources/streets/GET_STREETS_SUCCESS'
export const GET_STREETS_ERROR = 'resources/streets/GET_STREETS_ERROR'

export const FETCH_STREET_REQUEST = 'resources/streets/FETCH_STREET_REQUEST'
export const FETCH_STREET_SUCCESS = 'resources/streets/FETCH_STREET_SUCCESS'
export const FETCH_STREET_FAILURE = 'resources/streets/FETCH_STREET_FAILURE'
